// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1166":"ec683764","2612":"a6506f96","4022":"62fd872d","4247":"e70b9d3a","8810":"bc8a8a01"}[chunkId] + ".chunk.css";
};